<template>
  <div v-if="item">
    <h2>#{{ item.id }}</h2>
    <fields-list :item="item" :fields="fields" />
    <div class="save-panel">
      <button class="btn btn-sm btn-success btn-icon mt-4" @click="updateItem">
        <span class="ti-save"></span>Сохранить
      </button>
    </div>
  </div>
</template>

<script>
import { cardUpdate, cardContent } from "../../../plugins/functions";

import FieldsList from "../FieldsList";

export default {
  data: () => ({
    cardLink: "banners/card",
    cardSetLink: "banners/update",
    item: null,
    fields: [
      {
        col: "col-12 col-md-12",
        key: "is_active",
        label: "Активен",
        type: "checkbox", //textarea, field, checkbox
        textType: "text",
      },
      {
        col: "col-12 col-md-12",
        key: "is_modal",
        label: "Открыть в модальном",
        type: "checkbox", //textarea, field, checkbox
        textType: "text",
      },
      {
        col: "col-12 col-md-12",
        key: "title",
        label: "Название",
        type: "field", //textarea, field, checkbox
        textType: "text",
      },
      {
        col: "col-6 col-md-3",
        key: "width",
        label: "Ширина ПК (px)",
        type: "field", //textarea, field, checkbox
        textType: "text",
      },
      {
        col: "col-6 col-md-3",
        key: "height",
        label: "Высота ПК (px)",
        type: "field", //textarea, field, checkbox
        textType: "text",
      },
      {
        col: "col-6 col-md-3",
        key: "m_width",
        label: "Ширина Моб. (px)",
        type: "field", //textarea, field, checkbox
        textType: "text",
      },
      {
        col: "col-6 col-md-3",
        key: "m_height",
        label: "Высота Моб. (px)",
        type: "field", //textarea, field, checkbox
        textType: "text",
      },
    ],
  }),
  components: {
    FieldsList,
  },
  props: ["id"],
  async created() {
    this.item = await this.cardContent(this.cardLink, this.id);
  },
  methods: {
    cardUpdate: cardUpdate,
    cardContent: cardContent,
    updateItem() {
      this.cardUpdate(this.cardSetLink, this.item);
    },
  },
};
</script>
<style>
</style>
